<template>
    <ConfirmDialog group="dialog" />
    <div class="p-grid">
        <!-- <div class="p-col-12 p-pb-0">
            <Button @click="$router.go(-1)" label="Go Back" icon="pi pi-angle-left" class="p-button-text p-mr-2 p-mb-2" />
        </div> -->
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4><strong>알림상세</strong></h4>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">제목:</label>
                    <div class="p-col-12 p-md-10">
                        <!-- <span v-if="mydata.notification_type == 'manual'">
                         {{ mydata.notification_title }}
                        </span>
                        <span v-else>
                         {{ mydata.coupon_title }}
                        </span> -->

                        {{ mydata.notification_title }}
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">상세:</label>
                    <div class="p-col-12 p-md-10">{{ mydata.description }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">이미지:</label>
                    <div>
                        <Image :src="image" :alt="image" class="product-image" width="137" height="85" preview />
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">등록일:</label>
                    <div class="p-col-12 p-md-10">
                        <span v-if="mydata.notification_type == 'coupon'">
                            {{ dateformat(mydata.posted_date) }}
                        </span>
                        <span v-else>
                            {{ dateformat(mydata.created_date) }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="p-col-12 p-p-0">
        <div class="card">
            <div>
                <h5>유저목록</h5>
            </div>
            <DataTable :value="assignedUser" :paginator="true" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" :loading="loading1" :filters="filters1" responsiveLayout="scroll" v-model:selection="selected">
                <!-- v-model:selection="selected" -->
                <ConfirmDialog group="dialog" />

                <template #empty> No Data found. </template>
                <template #loading> Loading data. Please wait. </template>

                <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                <Column field="slNO" :header="$t('#')">
                    <template #body="{ index }">
                        <span class="p-column-title">Name</span>
                        {{ index + 1 }}
                    </template>
                </Column>
                <Column field="name" header="닉네임" style="min-width: 12rem">
                    <template #body="{ data }">
                        <span class="p-column-title">Nickname</span>
                        {{ data.nickname }}
                    </template>
                </Column>
                <Column :header="$t('ID')" style="min-width: 12rem">
                    <template #body="{ data }">
                        <span class="p-column-title">Id</span>
                        {{ data.username }}
                    </template>
                </Column>
                <Column header="Point" style="min-width: 12rem">
                    <template #body="{ data }">
                        <span class="p-column-title">Point</span>
                        {{ data.points }}
                    </template>
                </Column>
                <Column header="성별" style="min-width: 12rem">
                    <template #body="{ data }">
                        <span class="p-column-title">gender</span>
                        {{ data.gender }}
                    </template>
                </Column>
                <Column header="연령대" style="min-width: 12rem">
                    <template #body="{ data }">
                        <span class="p-column-title">Age Group</span>
                        {{ data.age_group }}
                    </template>
                </Column>
                <Column header="혼인여부" style="min-width: 12rem">
                    <template #body="{ data }">
                        <span class="p-column-title">Marital Status</span>
                        {{ data.married == 1 ? 'Married' : 'Unmarried' }}
                    </template>
                </Column>
                <Column header="자녀여부" style="min-width: 12rem">
                    <template #body="{ data }">
                        <span class="p-column-title">Children</span>
                        {{ data.has_children == 1 ? 'Yes' : 'No' }}
                    </template>
                </Column>
                <Column header="자녀연령대" style="min-width: 12rem">
                    <template #body="{ data }">
                        <span class="p-column-title">Children Age</span>
                        {{ $t(data.children_age == null ? '-' : data.children_age) }}
                    </template>
                </Column>
                <Column header="반려동물여부" style="min-width: 12rem">
                    <template #body="{ data }">
                        <span class="p-column-title">Pets</span>
                        {{ data.has_pets == 1 ? 'Yes' : 'No' }}
                    </template>
                </Column>
                <Column header="반려동물타입" style="min-width: 12rem">
                    <template #body="{ data }">
                        <span class="p-column-title">Pets Type</span>
                        {{ $t(data.pet_type == null ? '-' : data.pet_type) }}
                    </template>
                </Column>
                <Column header="계정상태" style="min-width: 12rem">
                    <template #body="{ data }">
                        <span class="p-column-title">Account Status</span>
                        {{ data.status }}
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>
    <div class="p-col-12">
        <div class="p-d-flex p-jc-between">
            <div>
                <!-- <router-link :to="'/user/edit-user/' + $route.params.id"
                    ><Button label="help" class="p-button-outlined p-button-help p-mr-2 p-mb-2"><i class="pi pi-user-edit p-mr-2"></i> Edit</Button></router-link
                > -->
                <Button @click="del($route.params.id)" label="delete" class="p-button-outlined p-button-danger p-mr-2 p-mb-2"><i class="pi pi-trash p-mr-2"></i> 삭제</Button>
            </div>
            <div>
                <Button @click="$router.go(-1)" label="Go Back" class="p-button-outlined p-mr-2 p-mb-2" />
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import NotificationService from '../../service/API/NotificationService';

// import {useRouter} from 'vue-router'
export default {
    data() {
        return {
            dropdownItems: [
                { name: 'male', code: 'male' },
                { name: 'female', code: 'female' },
                { name: 'others', code: 'others' },
            ],
            dropdownItem: null,
            mydata: {},
            assignedUser: [],
            notification_title: '',
            description: '',
            image: '',
            created_date: '',
            posted_date: '',
            nickname: '',
            username: '',
            points: '',
            gender: '',
            age_group: '',
            married: '',
            notification_type: '',
            coupon_title: '',
            del_id: '',
            notification_code: '',
        };
    },
    created() {
        this.notificationService = new NotificationService();
    },
    methods: {
        del(id) {
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    axios({ method: 'post', url: `/notification/remove`, data: { notification_code: id } })
                        .then((res) => {
                            console.warn(res);
                            this.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 });
                            setTimeout(() => {
                                this.$router.push({ name: 'NotificationList' });
                            }, 1000);
                        })
                        .catch((err) => {
                            if (err.response.data.statusCode == '401') {
                                localStorage.removeItem('token');
                                window.location.href = '/login';
                            }
                        });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
        dateformat(value) {
            if (value) {
                console.log();
                // return moment(String(value)).locale('ko').format('LLL')
                return moment(String(value)).locale('en').format('YYYY-MM-DD h:mm:ss');
            }
        },
    },
    mounted() {
        this.notificationService.NotificationDetails(this.$route.params.id, localStorage.getItem('NotificationType')).then((data) => {
            console.log(data);
            this.mydata = data.data[0];
            this.image = data.data[0].image;
            console.log(data[0]);
            this.assignedUser = data.assignedUser;
        });
    },
};
</script>
<style scoped>
.p-fluid .p-button {
    width: auto;
}
</style>
